// Booking helpers shared by the Ride / Airport / Little Buraq / By the Hour forms (website). The server is the judge; these give instant messages.
import { tidyName } from './meetGreet';

export const SCHEDULED_AFTER_MINUTES = 120;      // pickup further away than this is a "scheduled" ride (anywhere we serve); closer is a ride now (New York City)

const LINKISH = /(https?:|www\.|ftp:|mailto:|tel:|javascript:|@|:\/\/|[<>])/i;

// ISO-ish date 'YYYY-MM-DD' + time 'HH:mm' (New York wall clock as the browser sees it) -> Date, or null.
export function pickupDate(date, time) {
  if (!date) return null;
  const m = String(time || '').match(/^(\d{1,2}):(\d{2})(?:\s*([AP]M))?$/i);
  let hh = 0; let mm = 0;
  if (m) {
    hh = parseInt(m[1], 10); mm = parseInt(m[2], 10);
    if (m[3]) { const pm = m[3].toUpperCase() === 'PM'; hh = (hh % 12) + (pm ? 12 : 0); }
  }
  const d = new Date(`${date}T${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isScheduledFar(date, time, now = new Date()) {
  const d = pickupDate(date, time);
  return !!d && d.getTime() - now.getTime() > SCHEDULED_AFTER_MINUTES * 60000;
}

// The line under "Ride confirmed": scheduled more than 2 hours ahead -> "Your ride is scheduled for Oct 12, 4:30 PM"; otherwise today's message.
export function confirmationLine(date, time, now = new Date()) {
  if (!isScheduledFar(date, time, now)) return null;
  const d = pickupDate(date, time);
  const day = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const clock = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `Your ride is scheduled for ${day}, ${clock}`;
}

export function passengerProblem(name) {
  const v = tidyName(name);
  if (!v) return "Enter the passenger's name.";
  if (v.length > 80) return "The passenger's name can be at most 80 characters.";
  if (LINKISH.test(v)) return "The passenger's name can't contain links or symbols like < >.";
  return '';
}

export function phoneProblem(phone) {
  const v = String(phone || '').trim();
  if (!v) return '';
  const digits = v.replace(/\D/g, '');
  return digits.length >= 10 && digits.length <= 15 ? '' : 'Enter a valid phone number, or leave it empty.';
}

export function shortText(value, max) {
  const v = tidyName(value);
  if (!v) return '';
  return v.slice(0, max);
}

export async function fetchAirportAt(base, token, lat, lng) {
  if (lat == null || lng == null) return null;
  const r = await fetch(`${base}/api/airports/at?lat=${lat}&lng=${lng}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) return null;
  const j = await r.json();
  return j && j.airport ? { ...j.airport, meetGreet: j.meetGreet || null } : null;
}
